import React, { Component } from 'react';
import ProjectItem from './project_item';

class ProjectItems extends Component {
  render() {
    const projectItems = [
      {
        title: 'ToneQuest',
        description: 'is a guitar pedal review site and virtual pedalboard built with React and Ruby on Rails.',
        img_url: 'img/ToneQuest.png',
        url: 'https://tone-quest.herokuapp.com',
        repo: 'https://github.com/jsc215/tone-quest'
      },
      {
        title: 'Rate-A-Hero',
        description: 'is a Superhero review site built with React and Ruby on Rails.',
        img_url: 'img/RateAHero.png',
        url: 'https://rate-a-superhero.herokuapp.com',
        repo: 'https://github.com/apugliese36/rate-a-hero'
      },
      {
        title: 'Abington Reunion Contact App',
        description:
          'is a MEAN stack app used to aggregate contacts for a 20 year high school reunion. Restful api endpoints were created using Node.js and presented on the front end with Angular 6. Features include: authentication, password hashing and encryption, jsonwebtoken and route guards in Angular',
        img_url: 'img/abington.png',
        url: 'https://abington-reunion-app.onrender.com',
        repo: 'https://github.com/jsc215/reunion-contact-app'
      },
      {
        title: 'The Lyric Finder',
        description: 'is a React app that uses the lyricsovh API to fetch song lyrics.',
        img_url: 'img/TheLyricFinder.png',
        url: 'https://TheLyricFinder.herokuapp.com',
        repo: 'https://github.com/jsc215/lyric-finder'
      },
      {
        title: 'Pomodoro Timer',
        description:
          'is a timer app that implements the Pomodoro Technique for time management.  The technique uses a timer to break down work into intervals, traditionally 25 minutes in length, separated by short breaks. This particular timer is set up to work for four 25 minute intervals followed by a 5-minute break. After the fifth 25-minute work interval there is a 15-minute break and the process automatically resets. The project was built using Angular 6 and Bootstrap 4.',
        img_url: 'img/pomodoroTimer.png',
        url: 'https://pomodoro-timer-6vor.onrender.com',
        repo: 'https://github.com/jsc215/pomodoro-timer'
      }
    ];

    const items = projectItems.map((item) => {
      return (
        <ProjectItem
          key={item.title}
          title={item.title}
          description={item.description}
          url={item.url}
          img_url={item.img_url}
          repo={item.repo}
        />
      );
    });

    return (
      <div className="container projects">
        <div className="row mono">{items}</div>
      </div>
    );
  }
}
export default ProjectItems;



// WEBPACK FOOTER //
// ./src/components/project_items.js